import { StatusPill } from './ui';
import type { EngineState } from '../lib/engine';

function statusFor(state: EngineState): { tone: 'idle' | 'live' | 'busy' | 'alert'; label: string } {
  switch (state.phase) {
    case 'arming':
      return { tone: 'busy', label: 'Armed' };
    case 'recording':
      return { tone: 'live', label: 'Recording' };
    case 'paused':
      return { tone: 'busy', label: 'Paused' };
    case 'indexing':
      return { tone: 'busy', label: 'Indexing' };
    case 'ready':
      return { tone: 'idle', label: 'Take ready' };
    case 'failed':
      return { tone: 'alert', label: 'Stopped' };
    default:
      return { tone: 'idle', label: 'Standing by' };
  }
}

export function Header({ state }: { state: EngineState }) {
  const status = statusFor(state);
  return (
    <header className="masthead">
      <div className="masthead__brand">
        <span className="aperture" aria-hidden="true">
          <span className="aperture__iris" />
          <span className="aperture__pupil" />
        </span>
        <span className="wordmark">
          Opale<span className="wordmark__tail">ye</span>
        </span>
        <span className="masthead__tagline">screen capture · trim · export</span>
      </div>
      <div className="masthead__status">
        {state.capture ? (
          <span className="chip chip--mono">
            {state.capture.width}×{state.capture.height} · {state.capture.fps}fps
          </span>
        ) : null}
        {state.displayLabel ? <span className="chip chip--truncate">{state.displayLabel}</span> : null}
        <StatusPill tone={status.tone}>{status.label}</StatusPill>
      </div>
    </header>
  );
}
